import BoardPatternFormTabs from './BoardPatternFormTabs';

const AddBoardPatternModal = ({ onClose, onSuccess }) => {
  return (
    <BoardPatternFormTabs
      pattern={null}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

export default AddBoardPatternModal;